export default __webpack_public_path__ + "static/media/website.cb4dd34c.png";